<div class="container-fluid flex-container">
  <div class="row progress-bar-container">
    <div class="row">
      <emm-progress-bar [isLoading$]="isLoading$" width="110"></emm-progress-bar>
    </div>
  </div>
  <div class="row" style="height: calc(100% - 122px);">
    <div class="col">
      <div class="row">
        <!-- Feature Scope/Menu Mode dropdown -->
        <emm-scope-picker
          (featureScopeSelected)="featureScopeSelected($event)"
        ></emm-scope-picker>
      </div>

      <div class="row">
        <!-- Effective date datepicker -->
        @if (selectedFeatureScope !== 'Client') {
          <emm-effective-date-selection
            [changeSets]="changeSets$ | async"
            [effectiveDate]="effectiveDate$ | async"
            [label]="'Effective date'"
            source="menu"
            (effectiveDateChange)="changeEffectiveDate($event)"
          ></emm-effective-date-selection>
        }
      </div>

      <div class="row">
        <!-- Location Set type dropdown -->
        <emm-location-set-type-picker
          [disabled]="isLoading$ | async"
          [selectedFeatureScope]="selectedFeatureScope$ | async"
          [selectedLocationSetType$]="selectedLocationSetType$"
          [locationSetTypes]="locationSetTypes$ | async"
          [removeLocationsInGmb]="removeLocationsInGmb$ | async"
          (locationSetTypeSelected)="locationSetTypeSelected($event)"
        ></emm-location-set-type-picker>
      </div>

      @if (selectedLocationSetType$ | async; as selectedLocationSetType) {
        <div class="row">
          <!-- Location set dropdown -->
          @if (!isChain) {
            <emm-location-set-picker
              [disabled]="isLoading$ | async"
              [isLocationSetTypeParent]="isLocationSetTypeParent$ | async"
              [locationSets]="childLocationSets$ | async"
              [venues]="venues$ | async"
              [parentLabel]="parentLabel$ | async"
              [parentLocationSets]="parentLocationSets$ | async"
              [selectedFeatureScope]="selectedFeatureScope$ | async"
              [selectedLocationSetType]="selectedLocationSetType"
              [selectedLocationSet$]="selectedLocationSet$"
              [selectedVenue$]="selectedVenue$"
              (locationSetFilter)="filterLocationSets($event)"
              (locationSetSelected)="locationSetSelected($event)"
              (venueSelected)="venueSelected($event)"
              (parentLocationSetSelected)="parentLocationSetSelected($event)"
              (resetSelected)="resetSelectedLocationSet()"
              (resetSelectedVenue)="resetSelectedVenue()"
            ></emm-location-set-picker>
          }
        </div>
      }

      <div class="row">
        <!-- Consumer dropdown -->
        @if ((selectedFeatureScope$ | async) !== 'Global' && selectedLocationSet$ | async) {
          <div>
            <emm-consumer
              [consumers]="consumers$ | async"
              (consumerSelected)="consumerSelected($event)"
            ></emm-consumer>
          </div>
        }
      </div>
    </div>
  </div>
</div>
